import React from "react";

function Navbar(props) {
  return (
    <div className=" flex justify-evenly fixed w-[100%] z-10 bg-black pb-[1.5rem] pt-2 lg:pt-[3.5rem]">
      <div>
        <svg
          onClick={props.onClickHome}
          className="w-[1.5rem] h-[1.5rem] fill-white cursor-pointer lg:hidden"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path
            id="homeSVG"
            d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
          />
        </svg>
        <label
          onClick={props.onClickHome}
          className=" hidden lg:block cursor-pointer hover:underline hover:text-gray-200"
        >
          Home
        </label>
      </div>
      <div>
        <svg
          className="w-[1.5rem] h-[1.5rem] fill-white cursor-pointer lg:hidden"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            id=""
            d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
          />
        </svg>
        <label className=" hidden lg:block cursor-pointer hover:underline hover:text-gray-200">
          Profile
        </label>
      </div>
      <div>
        <svg
          onClick={props.onClickCart}
          className="w-[1.5rem] h-[1.5rem] fill-white cursor-pointer lg:hidden"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path
            id="cartSVG"
            d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H179.9l-9.1-48h317c14.3 0 26.9-9.5 30.8-23.3l54-192C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm336-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
          />
        </svg>
        <label
          onClick={props.onClickCart}
          className=" hidden lg:block cursor-pointer hover:underline hover:text-gray-200"
        >
          Cart
        </label>
        <label className=" text-[0.7rem] rounded-full px-[7px] bg-blue-700 absolute left-[63%] top-[0%] lg:left-[61%] lg:top-[44%] lg:text-[0.8rem]">
          {props.cartItemsCount}
        </label>
      </div>
      <div>
        <svg
          className="w-[1.5rem] h-[1.5rem] fill-white cursor-pointer lg:hidden"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            id=""
            d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
          />
        </svg>
        <label className=" hidden lg:block cursor-pointer hover:underline hover:text-gray-200">
          Options
        </label>
      </div>
    </div>
  );
}

export default Navbar;
